import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ListiniComponent } from './listini';

export const ListiniModule: string = ng
    .module('archiSmall.components.listiniModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('listiniComponent', ListiniComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/listini/listini.module.ts